
export const reportTikTokPixelTrial = (conversionId: string) => {
    if (typeof window.ttq !== 'undefined' && typeof window.ttq.track === 'function') {
        window.ttq.track('SubmitForm', {
            content_id: conversionId,
            content_type: 'product' // TikTok requires one of: product, product_group, destination, hotel, flight, vehicle
        });
    }
};


export const identifyTikTokPixelUser = (email?: string | null) => {
    if (typeof window.ttq !== 'undefined' && typeof window.ttq.identify === 'function' && email) {
        window.ttq.identify({ email: email });
    }
}
